import React, { Component } from 'react';

import { Route, Switch } from 'react-router-dom';
import OpenDouble from './event/OpenDouble';
import OpenSignUp from './event/OpenSignUp';
import StudioContestPopup from './event/StudioContestPopup';
import AddSNSLinkPopup from './event/AddSNSLinkPopup';
import NotMatch from './NotMatch';

class Event extends Component{


  render() {
      return (
        <Switch>
          <Route exact path="/event" component={OpenDouble}/>
          <Route path="/event/double" component={OpenDouble}/>
          <Route path="/event/signup" component={OpenSignUp}/>
          <Route path="/event/studiocontest" component={StudioContestPopup}/>
          <Route path="/event/addsnslink" component={AddSNSLinkPopup}/>
          <Route component={NotMatch}/>
        </Switch>
      )
    }



}//end Upload class

export default Event;
